import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { ProfileAvatar } from '@confluence/profile/entry-points/ProfileAvatarComponent';

import { ActionTime } from '../ActionTime';

import { ActivityLineUpdateLink } from './ActivityLineUpdateLink';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionWrapper = styled.div({
	display: 'flex',
	minHeight: '34px',
	marginBottom: token('space.150'),
});

const profileWrapperStyles = xcss({
	marginRight: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionMessage = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> a': {
		'&:hover': {
			color: token('color.text'),
		},
		color: token('color.text'),
		font: token('font.body'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionTimeWrapper = styled.div({
	font: token('font.body.small'),
	color: token('color.text'),
});

type Props = {
	type: 'COMMENT' | 'CREATE' | 'EDIT' | 'EDITLIVE' | 'PUBLISHLIVE';

	actionTime: string;
	userId: string | null;
	avatarUrl: string;
	userDisplayName: string | null;

	link: string;
	groupSize: number;
};

export const ActivityLineUpdateDetail: FC<Props> = ({
	type,
	actionTime,
	userId,
	avatarUrl,
	userDisplayName,
	link,
	groupSize,
}) => {
	return (
		<ActionWrapper data-testid="activity-update-detail">
			<Box xcss={profileWrapperStyles}>
				<ProfileAvatar userId={userId} src={avatarUrl} canViewProfile size="medium" />
			</Box>
			<ActionMessage>
				<ActivityLineUpdateLink
					type={type}
					userDisplayName={userDisplayName}
					link={link}
					groupSize={groupSize}
					activityDropdownLineItem
				/>
				<ActionTimeWrapper>
					<ActionTime actionTime={actionTime} />
				</ActionTimeWrapper>
			</ActionMessage>
		</ActionWrapper>
	);
};
